module.exports = __webpack_public_path__ + "static/img/39.452a6e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/39.png
// module id = tvl0
// module chunks = 0